import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/dal';
import { DalModule } from '@upr-web-primer/dal';
import * as i4 from '@upr-web-primer/digital-data';
import { DigitalDataModule } from '@upr-web-primer/digital-data';
import { HttpHeaders } from '@angular/common/http';
import * as i5 from '@upr-web-primer/geolocation';
import { GEO_NON_PRIMARY_RESIDENT_VALUE } from '@upr-web-primer/geolocation';
import * as i3 from '@upr-web-primer/locale';
import * as i2 from '@upr-web-primer/ms-guests';
import { WINDOW } from '@upr-web-primer/window';
import { get, isArray } from 'lodash-es';

class MsPersonalizationService {
    constructor(dal, guest, localeService, digitalDataService, geoLocationService, window, appDefaults, relativeUrls) {
        this.dal = dal;
        this.guest = guest;
        this.localeService = localeService;
        this.digitalDataService = digitalDataService;
        this.geoLocationService = geoLocationService;
        this.window = window;
        this.appDefaults = appDefaults;
        this.relativeUrls = relativeUrls;
        this.instanceId = this.guest.helper.getInstanceId();
    }
    getInteractData(interact_points, relyOnExistingSessionFlag = true) {
        const relativeUrl = this.replaceCode(this.relativeUrls.NEXT_BEST_ACTIONS);
        const headers = this.getHeaders();
        const geo = this.geoLocationService.getGeoLocationObject();
        const geoLocation = geo?.region !== GEO_NON_PRIMARY_RESIDENT_VALUE ? 'FL' : 'OUS';
        const aamId = get(this.window, 'digitalData.user.idAAM', '');
        const guestId = localStorage.getItem('LOGGEDIN_GUEST_ID') || '';
        const request = {
            instance_attributes: {
                audiences: [
                    {
                        system: 'Adobe',
                        ids: '[123, 456]',
                    },
                ],
                amm_id: aamId,
            },
            geo_location: geoLocation,
            in_market: geoLocation === 'FL',
            in_resort: false,
            session_id: this.instanceId,
            first_time_visitor: get(this.window, 'digitalData.user.daysSinceLastVisit', 0) === 0,
            offer_requests: [...interact_points],
            guest_id: guestId,
            ddl: get(this.window, 'digitalData', {}),
            relyOnExistingSession: relyOnExistingSessionFlag,
        };
        if (!aamId) {
            delete request.instance_attributes;
        }
        if (!guestId) {
            delete request.guest_id;
        }
        return this.dal.httpRequest(relativeUrl, 'POST', request, headers);
    }
    getContent(contentIds) {
        let listOfContentId;
        const locale = this.localeService.getFromStorage();
        const language = locale?.language;
        const country = locale?.country?.toUpperCase();
        const httpOptions = new HttpHeaders({
            'Accept-Language': `${language}-${country}` + (language === 'es' ? ',en-US' : ''),
        });
        if (isArray(contentIds)) {
            listOfContentId = contentIds.filter((contentId) => contentId !== undefined);
            listOfContentId = listOfContentId.join(',');
        }
        else {
            listOfContentId = contentIds;
        }
        const relativeUrl = this.replaceCode(this.relativeUrls.FETCH_CONTENT) + listOfContentId;
        return this.dal.httpRequest(relativeUrl, 'GET', {}, httpOptions);
    }
    acceptOffer(btnData) {
        if (!btnData)
            return;
        const response_code = get(btnData, 'type_code') === -1
            ? null
            : get(btnData, 'inbound_response_type_code');
        this.acceptNextBestActions(response_code, btnData.ip, btnData.treatment_code).catch((error) => {
            console.log(error);
            const effect = btnData.ip + ' | ' + btnData.contentId;
            this.digitalDataService.logEvent(false, 'Accept Offer', 'Click', effect, 'Interact', btnData);
        });
    }
    acceptNextBestActions(responseCode, ip, tCode) {
        const relativeUrl = this.replaceCode(this.relativeUrls.ACCEPT_NEXT_BEST_ACTIONS);
        const headers = this.getHeaders();
        const request = {
            offer_requests: [
                {
                    response_code: responseCode,
                    ip: ip,
                    treatment_code: tCode,
                },
            ],
            session_id: this.instanceId,
        };
        return this.dal.httpRequest(relativeUrl, 'POST', request, headers);
    }
    getHeaders() {
        let httpHeaders = new HttpHeaders();
        this.instanceId = this.guest.helper.getInstanceId();
        if (!!this.instanceId) {
            httpHeaders = httpHeaders.append('x-instance-id', this.instanceId);
        }
        return httpHeaders;
    }
    replaceCode(url) {
        return url
            ? url.replace('{resortAreaCode}', this.appDefaults.PERSONALIZE_RESORT_CODE)
            : '';
    }
}
MsPersonalizationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationService, deps: [{ token: i1.DalService }, { token: i2.MsGuestsService }, { token: i3.LocaleService }, { token: i4.DigitalDataService }, { token: i5.GeolocationService }, { token: WINDOW }, { token: 'AppDefaults' }, { token: 'RelativeUrls' }], target: i0.ɵɵFactoryTarget.Injectable });
MsPersonalizationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.DalService }, { type: i2.MsGuestsService }, { type: i3.LocaleService }, { type: i4.DigitalDataService }, { type: i5.GeolocationService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['AppDefaults']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['RelativeUrls']
                }] }]; } });

class MsPersonalizationModule {
}
MsPersonalizationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MsPersonalizationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationModule, imports: [DigitalDataModule, DalModule] });
MsPersonalizationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationModule, providers: [MsPersonalizationService], imports: [[DigitalDataModule, DalModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MsPersonalizationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [DigitalDataModule, DalModule],
                    providers: [MsPersonalizationService]
                }]
        }] });

export { MsPersonalizationModule, MsPersonalizationService };
